import { render, staticRenderFns } from "./handleVerbalTrick.vue?vue&type=template&id=46b6eef3"
import script from "./handleVerbalTrick.vue?vue&type=script&lang=js"
export * from "./handleVerbalTrick.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports